/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const CustomizedErrorStateWrapper = styled.section({
  textAlign: 'center',
  padding: '128px 0',
});

export const CustomizedErrorStateLogo = styled.img({
  width: '200px',
  height: '200px',
});

export const CustomizedErrorStateTitle = styled.h1({
  margin: `${token('space.200')} 0 ${token('space.150')}`,
});
